import debounce from 'lodash/debounce'
import { useEffect, useMemo, useRef } from 'react'

const DEFAULT_DEBOUNCE_DELAY = 3000

export const useDebouncedCallback = <T extends (...args: any[]) => void>(
  callback: T,
  delay: number = DEFAULT_DEBOUNCE_DELAY,
): ReturnType<typeof debounce<T>> => {
  const callbackRef = useRef(callback)
  // Keep latest callback in ref to avoid stale closures inside debounce
  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  return useMemo(() => debounce((...args: Parameters<T>) => callbackRef.current(...args), delay), [delay])
}
